import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { useAuth } from '../App.jsx';

/**
 * Конфигурационните параметри — само за четене.
 *
 * Приложение № 29, т. 19 иска одиторският профил да има достъп до
 * конфигурационните параметри на софтуера. Досега те живееха само в
 * базата: нямаше екран, от който да се видят.
 *
 * Страницата е нарочно само за гледане. Настройките се менят там, където
 * им е мястото — фирмата в своя екран, пощата в своя; тук се вижда какво
 * е зададено, събрано на едно място.
 */

/** Имената на ключовете, както ги нарича човек. */
const IMENA = {
  company: 'Данни на фирмата',
  fiscal_device: 'Фискално устройство',
  unp: 'Уникален номер на продажбата',
  vat_default_rate: 'Ставка на ДДС по подразбиране',
  base_currency: 'Базова валута',
  rounding: 'Закръгляне',
  credit: 'Отложено плащане',
  test_mode: 'Пробен режим',
  mail_test: 'Пробен режим на пощата',
  woocommerce: 'Връзка към сайта',
  debt_letter: 'Писмо до длъжници',
  poli_email: 'Имейл на счетоводството',
};

/** Обяснение защо параметърът съществува — за проверяващия. */
const ZASHTO = {
  fiscal_device: 'Моделът и индивидуалният номер на устройството, с което се '
    + 'формира УНП по т. 9.',
  unp: 'Серийният номер на устройството и броячът на продажбите.',
  test_mode: 'Забранен от т. 20 — премахва се преди работа с реални продажби.',
};

export default function Settings() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/api/settings').then(setData).catch((e) => setError(e.message));
  }, []);

  if (error) return <div className="error">{error}</div>;
  if (!data) return <div className="card"><div className="empty">Зареждане…</div></div>;

  const kljuchove = Object.keys(data).sort((a, b) =>
    (IMENA[a] ?? a).localeCompare(IMENA[b] ?? b, 'bg'));

  return (
    <>
      <div className="page-head">
        <h1>Настройки на системата</h1>
        <div className="spacer" />
        <span className="muted">само за преглед</span>
      </div>

      <p className="hint">
        Конфигурационните параметри, до които Приложение № 29, т. 19 иска
        достъп. Ключовете за връзка към други системи не се показват.
      </p>

      {kljuchove.map((k) => (
        <div className="card" key={k}>
          <div className="card-head">
            {IMENA[k] ?? k}
            <span className="muted" style={{ fontWeight: 400 }}> · {k}</span>
          </div>
          <div className="card-body">
            {ZASHTO[k] && <p className="hint" style={{ marginTop: 0 }}>{ZASHTO[k]}</p>}
            <Stojnost v={data[k]} />
          </div>
        </div>
      ))}

      {user.role === 'auditor' && (
        <p className="hint">
          Профилът ви е одиторски: вижда всичко, но не променя нищо.
        </p>
      )}
    </>
  );
}

/** Стойността: обект се показва като таблица, останалото както е. */
function Stojnost({ v }) {
  if (v == null) return <span className="muted">празно</span>;
  if (typeof v !== 'object') return <span>{String(v)}</span>;

  const redove = Object.entries(v);
  if (redove.length === 0) return <span className="muted">празно</span>;

  return (
    <table className="compact">
      <tbody>
        {redove.map(([k, x]) => (
          <tr key={k}>
            <td className="muted" style={{ width: 220 }}>{k}</td>
            <td>
              {x == null ? <span className="muted">празно</span>
                : typeof x === 'object' ? <code>{JSON.stringify(x)}</code>
                  : typeof x === 'boolean' ? (x ? 'да' : 'не')
                    : String(x)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
